import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedStepApiService } from './step-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class StepApiService extends GeneratedStepApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
